import { projectNameSmall } from "src/Config";

export const setTitle = (title: string) => {
    document.title = `[${projectNameSmall}] ${title}`;
}

export const reducer = <T>() => (state: T, newState: Partial<T>): T => ({
    ...state,
    ...newState
})